import { render, staticRenderFns } from "./AppEmbed.vue?vue&type=template&id=25a41ef9"
import script from "./AppEmbed.vue?vue&type=script&lang=js"
export * from "./AppEmbed.vue?vue&type=script&lang=js"
import style0 from "./AppEmbed.vue?vue&type=style&index=0&id=25a41ef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports